/**
 * @module FE-CU36_パスコード設定画面
 */
import Header from '../../components/header/Header';
import AgreementDialog from '../../components/modal/agreementDialog.vue';
import MessageDialog from '../../components/modal/messageDialog.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import NativeApi from '../../api/nativeApi';
import NativeCallback from '../../api/nativeCallback';
import MobileFooter from '@/components/footer/MobileFooter.vue';

const PAGE_ID = 'FE-CU36';

export default {
  name: 'PasscodeSettings',
  components: {
    Header,
    AgreementDialog,
    MessageDialog,
    PCFooter,
    MobileFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU36パスコード設定画面.パスコード設定'), //"パスコード設定",
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU36パスコード設定画面.C0001'), // "アプリのパスコードを設定・変更を行うことができます。\n設定したパスコードは、ログイン時、ユーザー警備操作時に使用しますので、大切に保管してください。",

      passcode: '',
      firstPasscode: '',
      secondPasscode: '',
      isConfirmMode: false,
      cancelButtonType: 1,
      okButtonType: 0,
      callbackResult: {
        loginSetting: {
          errorCode: '',
        },
        settingApp: {
          errorCode: '',
        },
      },
      pageFromFrom: '', // 2つ前の画面が何であったかを保持. (各種設定画面あるいは2段階認証画面 -> ログイン方法設定画面 -> 本画面, という遷移）
      countdown: 0,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU36パスコード設定画面.パスコード設定'), //"パスコード設定",
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU36パスコード設定画面.C0001'), // "アプリのパスコードを設定・変更を行うことができます。\n設定したパスコードは、ログイン時、ユーザー警備操作時に使用しますので、大切に保管してください。",
      };
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * パスコードのclassを動的に設定
     * @param {number} idx パスコードid
     * @returns {string} class名
     */
    circleStyle(idx) {
      return this.passcode.length >= idx ? 'circle' : 'circle-outline';
    },
    /**
     * パスコード入力値を設定
     * @param {object} e イベント
     */
    numberInput(e) {
      if (this.isConfirmMode) {
        if (this.secondPasscode.length < 4) {
          if (e.data == null) {
            this.secondPasscode = this.secondPasscode.slice(0, -1);
          } else if (Number.parseInt(e.data) === +e.data) {
            this.secondPasscode += e.data;
          }
          this.passcode = this.secondPasscode;
          if (this.secondPasscode.length == 4) {
            this.checkInput();
          }
        }
      } else {
        if (this.firstPasscode.length < 4) {
          if (e.data == null) {
            this.firstPasscode = this.firstPasscode.slice(0, -1);
          } else if (Number.parseInt(e.data) === +e.data) {
            this.firstPasscode += e.data;
          }
          this.passcode = this.firstPasscode;

          if (this.firstPasscode.length == 4) {
            setTimeout(() => {
              this.isConfirmMode = true;
              this.passcode = '';
            }, 200);
          }
        }
      }
    },
    /**
     * 待機処理
     */
    wait() {
      // 画面の●が４つ埋まるのを表現する処理の猶予のために500ms一時停止する. 本処理が不要である可能性あり
      setTimeout(() => {
        // Do something
      }, 200);
    },
    /**
     * 確認用パスコードを４桁入力した時の処理を実装する
     */
    checkInput() {
      this.countdown = this.$isAndroidApp ? 2 : 1;
      NativeApi.registerLoginSetting(
        2, // 2: パスコード・生体認証ログイン
        this.firstPasscode,
        this.secondPasscode
      ); // -> watch"callbackResult.loginSetting"
    },
    /**
     * クリック時にフォーカスを設定
     */
    focusInput() {
      this.$refs.passcodeSettingsPasscodeInput.focus();
    },
    /**
     * 設定アプリを開く
     */
    goBiometricsSetting() {
      const target = 0; // 0: 設定アプリのトップ画面, 1: 新HSアプリ自身の設定画面 「Push通知の許可/禁止設定の切替をしたい場合は1を指定する」
      NativeApi.openSettingApp(target);
    },
    /**
     * 設定終了後の画面遷移処理
     */
    finishSetting() {
      // 本画面はログイン方法設定画面からのみ遷移する
      if (this.pageFromFrom === 'twoStepAuthentication') {
        if (sessionStorage.getItem('redirectPath')) {
          // redirect to notificationHistory page when tap from panel
          this.$router.push({
            path: sessionStorage.getItem('redirectPath'),
          });
        } else {
          this.$router.push({
            path: '/top',
          });
        }
      } else if (this.pageFromFrom === 'variousSettings') {
        this.$router.push({
          path: '/variousSettings',
        });
      } else {
        // このelseには入らない
        this.$router.push({
          path: '/sorry',
        });
      }
    },
    /**
     * 初期状態にリセット
     */
    resetInput() {
      setTimeout(() => {
        this.passcode = '';
        this.firstPasscode = '';
        this.secondPasscode = '';
        this.isConfirmMode = false;
      }, 200);
    },
  },
  watch: {
    //IF02のCallbackを監視
    async 'callbackResult.loginSetting'(newVal, oldVal) {
      this.countdown--;
      if (this.countdown > 0) return;
      const errorCode = this.$isAndroidApp ? oldVal.errorCode : newVal.errorCode;

      if (NativeCallback.codeInclude(errorCode, '02-C0000')) {
        const bio = this.$store.getters['appInfo/getIsBiometricAuthAvailable'];
        // 0: 未対応, 1: 利用可能, -1: ロック中, -2: 未登録
        if (bio === '-2') {
          // TODO仕様では「生体認証対応端末、 かつ生体情報未登録の場合」とあるが、画面上の挙動としては一旦、bio==="1"
          const result = await this.$agreementDialog(
            '$vuetify.FECU36パスコード設定画面.パスコード設定完了',
            '$vuetify.FECU36パスコード設定画面.パスコードの設定が完了しました生体情報が登録されていません',
            '$vuetify.FECU36パスコード設定画面.生体認証を設定',
            '$vuetify.FECU36パスコード設定画面.設定を終了',
            { cancelButtonType: this.cancelButtonType, okButtonType: this.okButtonType }
          );

          if (result) {
            // 生体認証を設定
            this.finishSetting();
          } else {
            // 設定を終了
            this.goBiometricsSetting();
          }
        } else {
          // TODO仕様では「生体認証未対応端末、 または生体認証対応端末で生体情報登録済みの場合」とあるが、一旦else
          await this.$informationDialog('$vuetify.メッセージ一覧.FECU36パスコード設定画面.C0003');

          this.finishSetting();
        }
      } else if (NativeCallback.codeInclude(errorCode, '02-E0002')) {
        await this.$errorDialog('$vuetify.メッセージ一覧.FECU36パスコード設定画面.E0002');

        this.resetInput();
      } else if (
        NativeCallback.codeInclude(errorCode, '02-E9999') ||
        NativeCallback.codeInclude(errorCode, '02-E0001')
      ) {
        await this.$errorDialog('$vuetify.メッセージ一覧.FECU36パスコード設定画面.E0003');

        this.resetInput();
      }
    },
    // IF03のCallbackを監視
    async 'callbackResult.settingApp'(newVal, oldVal) {
      if (oldVal.errorCode !== '') return;

      // 設定アプリ起動結果に関わらず、画面遷移させるのがよい?
      // if (NativeCallback.codeInclude(newVal.errorCode, "03-C0000")) {
      //   this.finishSetting();
      // }
      this.finishSetting();
    },
    deep: true,
  },
  beforeMount() {
    // Native部との通信を行うCallback関数をwindowオブジェクトに登録
    // IF02_ログイン設定記録要求
    window.onRegisterLoginSettingFinished = (errorCode) => {
      this.callbackResult.loginSetting = NativeCallback.onRegisterLoginSettingFinished(errorCode);
    };
    // IF03_設定アプリ表示要求
    window.onOpenSettingAppFinished = (errorCode) => {
      this.callbackResult.settingApp = NativeCallback.onOpenSettingAppFinished(errorCode);
    };
  },
  async mounted() {
    if (!this.$isMobileApp) {
      this.$router.replace({
        path: '/sorry',
      });
    }

    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);
    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }
    // TODOページリロードが入ってしまうため？初期表示のアニメーションがおかしくなる
    this.$refs.passcodeSettingsPasscodeInput.focus();

    // 前ページからのクエリを受け取る. 前の前のページを保持
    this.pageFromFrom = this.$route.query.fromfrom;
  },
  async beforeRouteLeave(to, from, next) {
    if (this.passcode.length < 4 && this.$store.getters['isLoggedIn']) {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.agreementDialog.設定が完了していません',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
        // "確認",
        // "設定が完了していません。\n\r画面遷移しますか？",
        // "いいえ",
        // "はい"
      );
      if (result === true) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },
};
